import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useStyles } from "./SubGroupPanel/styles";

const SubGroupPanel = ({
  title,
  children,
  selectStep,
  accordionProps,
  sessionsArray,
  infoString,
}) => {
  const classes = useStyles();

  return (
    <Accordion {...accordionProps}>
      <AccordionSummary
        className={classes.summary}
        expandIcon={<ExpandMoreIcon />}
      >
        <div className={classes.titleContainer}>
          <Typography variant="body1">{title}</Typography>
          {selectStep && infoString && (
            <Typography
              className={classes.detailInfo}
              variant="body2"
              color="textSecondary"
            >
              {infoString}
            </Typography>
          )}
        </div>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default SubGroupPanel;
